import React, { Component } from 'react';
import moment from 'moment';
import RoutingConstants from 'lib/RoutingConstants';
import { post } from 'lib/api';
import history from '../../history'
// eslint-disable-next-line
import UpgradePlan from './UpgradePlan';
// import ConfirmSubscription from './ConfirmSubscription';

class SubscriptionDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trial: this.props.reminder,
      inputs: {},
      ...this.props,
    };
  }

  componentDidMount() {
    if(this.props.planId === undefined) {
      this.getDetail(this.props.subscriptionPlan); 
    } else{
      this.getPlan (this.props.planId)
    }
  }
  

  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ trial: props.reminder, ...props });
    if(props.planId === undefined) {
      this.getDetail(props.subscriptionPlan); 
    } else{
      this.getPlan (props.planId, props.reminder)
    }
  }


  getDetail() {
    let { detailText } = this.state
    detailText = ' Free Trial Subscription';
    this.setState({ detailText, trial: true });
  }
  
  getPlan(planId) {
    // let { renewPlanDate, interval, mprice, trial } = this.state;
    // const { renewDate } = this.state;
    const { inputs } = this.state;
    let detailText = ''
    inputs.planId = planId
    const url = RoutingConstants.getPlanById;
    post(url, inputs ).then((response) => {
      detailText = `${response.result.plan_name} Subscription`;
      this.setState({detailText})
    }).catch(()=>{
    })
  }

  upgradePlan() {
    const { dayDates } = this.state
    // track subscribe click
    const id = localStorage.getItem('email')
    history.push('/billingPlan',{ path:'billing', dayDates})
    window.analytics.track('Trial User Subscribe Clicks',{id});
  }

  // confirmScreen(value) {
  //   this.setState({
  //     show: false,
  //   });
  // }

  render() {
    const { trial, trialEndDate } = this.state;
    let { activeMember, detailText, renewDate } = this.state;
    activeMember = moment(activeMember).format('MMMM DD, YYYY');
    const trialEnd = moment(trialEndDate).format('MMMM DD');
    
    detailText = detailText === '' || detailText === undefined? 'Monthly Subscription ' : detailText
    renewDate = renewDate === '' || renewDate === undefined? renewDate = moment().add(30, 'days').format('MMMM DD, YYYY') : moment(renewDate).format('MMMM DD, YYYY')

    return (
      <div className="free-trial-biling-dtail-box">
        <div className="row">
          {trial ?
            <div className="col-md-12">
              <div className="col-md-9">
                <h5 className="text-left data-hj-whitelist">Your Free Trial Ends: <span className="data-hj-whitelist">{trialEnd}</span></h5>
                <p className="fre-traial-end-dtail mb-hide">Sign up soon so you don’t lose access to your meal plans!</p>
              </div>
              <div className="col-md-3">
                <div className="back-to-planing-btn-box">
                  <button className="back-to-planing-btn" onClick={() => this.upgradePlan()}>
                Sign Up Now
                  </button>
                </div>
              </div>
              <div className="col-md-9">
                <p className="fre-traial-end-dtail mb-only">Sign up soon so you don’t lose access to your meal plans!</p>
              </div>
              
              
            </div>
            :
            <div className="col-md-12"> 
              <div className="col-md-9">
                <h5 className="text-left">Your Billing Details</h5>
                <p className="fre-traial-end-dtail">Thanks for being a customer!</p>
              </div>
              
            </div>
          }
        </div>
        <div className="row">
          <div className="col-md-9">
            <div className="free-trial-biling-inner-dtail">
              <p className="data-hj-whitelist">Sign up date: {activeMember}</p>
            </div>
            <div className="free-trial-biling-inner-dtail">
              {/* <p>Current Plan: <strong>{detailText}</strong></p> */}
              <p>Current Plan: <strong>{detailText}</strong></p>
              <p className="sub-hdng">
                {trial ? 
                  'You will loose access to meal plans when your free trial expires'
                  :
                  `The next time you'll be charged is ${renewDate}`
                }
              </p>

              {/* { !trial ?
                <div>
                  <p className="subscribe-today-msg">Renew Every {interval} at ${mprice}</p>
                  <p className="subscribe-today-msg subscribe-today-msg-two">
                    Next Renewal Date: {renewPlanDate}
                  </p>
                </div>
                :
                <p className="subscribe-today-msg">Subscribe today for just ${mprice} per month!</p>
              } */}
            </div>
          </div>
        </div>
        
      </div>
    );
  }
}

export default SubscriptionDetail;



// WEBPACK FOOTER //
// ./src/components/billingDetails/SubscriptionDetail.js